module.exports = __webpack_public_path__ + "img/1559830700.229e0dbb.jpg";